export const { default: TitleDashboard } = require("./TitleDashboard");
